<template>
  <div class='edit-website-images'>
    <page-header title='Edit website images' />
    <div class="container">
      <tab-nav :tabs="['gallery', 'splash', 'links']" :selectedTab="selectedTab" :onChange="changeTab" />
    </div>
    <div class='container'>
      <!-- SPLASH -->
      <!-- SPLASH -->
      <span v-if="selectedTab === 'splash'" class='tab-content'>
        <div class='row between c-v'>
          <div>
            <h4 class='mt-40'>Splash image</h4>
            <p>
              The splash image is the large background image displayed in the site's header <br />
              Image should be large enough to look good at full screen, and wider than it is tall. <br />
              It will be the first things customers see when they visit the site.
            </p>
          </div>
          <div>
                <button v-if="!editSpashImage" class='btn green mt-30 icon' @click="editSpashImageFormToggle">
                  <span>+</span>
                  Edit splash image
                </button>
                <button v-else class='btn red mt-30 icon' @click="editSpashImageFormToggle">
                  <span>x</span>
                  Cancel edit image
                </button>
            </div>
        </div>

        <div class='img-upload-module mb-30' v-if="editSpashImage">
          <label class='card-title'>Change splash image</label>
          <img v-if="previewSplash" :src="previewSplash" />
          <input
            type='file'
            @change="splashImageUploadHandler"
            accept="image/jpeg"
            id="splash-image-field"
          />
          <p class='em light ml-5 mt-10'>Use jpg file type</p>
          <div class='btn-group right' v-if="localSplashFile">
            <button
              class='btn red'
              @click="cancelChangeSplashHandler"
            >
              Cancel
            </button>
            <button
              class='btn green ml-10'
              @click="applyChangeSplashHandler"
            >
              Apply change
            </button>
          </div>
          <div class='btn-group right' v-else>
            <button
              class='btn red'
              v-if="!emptySplash"
              @click="restoreSplashImage"
            >
              Restore original splash
            </button>
          </div>
        </div>
        <span v-if="!emptySplash">
          <span class='current-splash-label'>Current splash image</span>
          <br />
          <img
            :src="splashImage"
            class='splash-image current-splash-image mb-15'
            alt="website splash image"
            v-if="splashImage"
          />
          <p v-else>Loading image...</p>
        </span>
      </span>
      <!-- GALLERY IMAGES -->
      <!-- GALLERY IMAGES -->
      <span v-if="selectedTab === 'gallery'" class='tab-content'>
        <div class='row between c-v'>
          <div>
            <h4 class='mt-40'>Gallery images</h4>
            <p>
              Images that will appear in the gallery and featured images on the home page. <br />
              Only six featured images will return at a time.        
            </p>
          </div>
          <div>
              <button v-if="!showAddImageForm" class='btn green mt-30 icon' @click="addImageFormToggle">
                <span>+</span>
                Add image
              </button>
              <button v-else class='btn red mt-30 icon' @click="addImageFormToggle">
                <span>x</span>
                Cancel add image
              </button>
          </div>
        </div>
        <!-- Add Gallery Image Form -->
        <div v-if="showAddImageForm" class='show-in-gallery-form'>
          <h5 class='card-title'>Add gallery image</h5>
          <img v-if="previewNewGalleryImage" :src="previewNewGalleryImage" />
          <input
            type='file'
            @change="galleryImageUploadHandler"
            accept="image/png, image/gif, image/jpeg"
            id="new-gallery-image-field"
          />
          <label> Image title </label>
          <input type='text' class='form-field' @input="(e) => updateNewImageForm('title', e.target.value)" />

          <label> Category </label>
          <div class='row between cat-group'>
            <input 
              type='text' 
              class='form-field' 
              :value="addGalleryImage.category"
              @input="(e) => updateNewImageForm('category', e.target.value)"
            />
            <select @change="(e) => updateNewImageForm('category', e.target.value)" name="add-img-cat">
              <option value=''> or choose existing </option>
              <option v-for="(cat, index) in categories" :key="index" :value="cat">
                {{ cat }}
              </option>
            </select>
          </div>
          <div class='row'>
            <div class='p-10'>
              <label>Show in gallery</label>
              <toggle 
                :value="addGalleryImage.showInGallery" 
                :name="'showInGal'" 
                :onChange="() => updateNewImageForm('showInGallery', !addGalleryImage.showInGallery)"
              />
            </div>
            <div class='p-10'>
              <label>Featured image</label>
              <toggle 
                :value="addGalleryImage.featured" 
                :name="'isFeatured'" 
                :onChange="() => updateNewImageForm('featured', !addGalleryImage.featured)"
              />
            </div>
          </div>
          <div class='tag-section'>
            <label>Tags</label>
            <TagList
              :list="addGalleryImage.tags"
              :onUpdateTag="updateTag"
            />
          </div>
          <div class='btn-group right mt-20'>
            <button class='red pad' @click="addImageFormToggle" :disabled="uploadingImage">Cancel</button>
            <button class='green pad ml-20' @click="submitNewGalleryImageHandler" :disabled="!previewNewGalleryImage || uploadingImage">
              {{ uploadingImage ? 'Uploading...' : 'Submit' }}
            </button>
          </div>
        </div>
        <!-- FILTER -->
        <div class='filter-controls row between c-v'>
          <div>
            <span> Display </span>
            <select @change="filterChange" name="filter" :value="filter">
              <option value='' disabled> Choose one </option>
              <option value='all' :selected="filter === 'all'"> All images </option>
              <option
                v-for="(cat, index) in categories"
                :key="index"
                :value="cat"
                :selected="filter === cat"
              >
                {{ cat }}
              </option>
            </select>
          </div>
          <p>Displaying {{ displayedImages.length }} of {{ galleryImages.length }} </p>
        </div>

        <!-- IMAGE LIST -->
        <gallery-image-list
          :images="displayedImages"
          :categories="categories"
          :saveImageData="saveImageData"
          :handleDeleteImageClick="handleDeleteImageClick"
        />
        <p v-if="galleryImages.length < 1" class="center pt-30 pb-20">No images to display</p>
        <p 
          v-if="galleryImages.length > 0 && displayedImages.length < 1"
          class="center pt-30 pb-20"
        >
          Choose a category to view images
        </p>
      </span>
      <span v-if="selectedTab === 'links'" class='tab-content'>
        <div class="row pt-20 break-large">
          <div class="p-10">
            <copy-card
              :label="'Gallery images'"
              :text="galleryLink"
            />
          </div>
          <div class="p-10">
            <copy-card
              :label="'Featured images'"
              :text="featuredLink"
            />
          </div>
          <div class="p-10">
            <copy-card 
              v-if="splashImage"
              :label="'Splash image url'"
              :text="splashImage.split('?')[0]"
            />
          </div>
        </div>
        <div class='p-10'>
          <strong>
            Images by category
          </strong>
          <div
            v-for="category in categories"
            :key="category"
            class='mt-10'
          >
            <copy-card
              :label="category"
              :text="`${categoryLink}${category}/`"
            />
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import TextComponent from '../../components/TextComponent'
import TabNav from '@/myComponents/TabNav'
import Toggle from '../../components/Toggle'
import CopyCard from '@/myComponents/CopyCard.vue';
import TagList from '../../components/TagList.vue'
import { api } from '../../services/api'
import PageHeader from '../../components/PageHeader.vue';
import GalleryImageList from '../../components/GalleryImageList.vue';
export default {
  name: "edit-site-images",
  components: { Toggle, TabNav, CopyCard, TagList, PageHeader, GalleryImageList },
  data: function(){
    return ({
      selectedTab: 'gallery',
      filter: '',
      editSpashImage: false,
      uploadingImage: false,
      localSplashFile: null,
      previewSplash: null,
      showAddImageForm: false,
      previewNewGalleryImage: null,
      addGalleryImage: {
        showInGallery: false,
        featured: false,
        title: '',
        image: null,
        category: null,
        tags: []
      },
      galleryImages: [],
      api
    })
  },
  mounted: async function() {
    if (!this.$store.getters.splashLoaded) {
      await this.$store.dispatch('loadSplashImage')
    }
    if (!this.gallery.loaded) {
      await this.$store.dispatch('loadGalleryImages')
      this.refreshGallery()
    } else {
      this.refreshGallery()
    }
    const filter = this.$route.params.imageCategory
    if (filter) this.filter = filter
  },
  methods: {
    changeTab (tab) {
      this.selectedTab = tab
    },
    updateTag (action, tag) {
      if (action === 'add') {
        this.addGalleryImage.tags.push(tag)
      } else this.addGalleryImage.tags =
        this.addGalleryImage.tags.filter(t => t !== tag)
    },
    refreshGallery(){
      this.galleryImages = [...this.gallery.data]
    },
    updateNewImageForm (name, val) {
      this.addGalleryImage[name] = val
    },
    addImageFormToggle () {
      const preview = document.getElementById('new-gallery-image-field')
      if (preview) {
        preview.value = ''
      }
      this.showAddImageForm = !this.showAddImageForm
      this.previewNewGalleryImage = null
      this.addGalleryImage = {
        showInGallery: false,
        featured: false,
        title: '',
        image: null,
        category: null,
        tags: [],
        tagField: ''
      }
    },
    editSpashImageFormToggle () {
      this.editSpashImage = !this.editSpashImage
    },
    applyChangeSplashHandler: async function () {
      if (this.localSplashFile && this.localSplashFile.files) {
        await this.$store.dispatch('updateSplashImage', this.localSplashFile.files)
        this.cancelChangeSplashHandler()
      }
    },
    restoreSplashImage: async function () {
      this.$store.commit("setModal", {
        component: TextComponent,
        mounted: true,
        header: "Confirm delete",
        props: {
          text:
            "Are you sure you want to restore the original splash image?"
        },
        goodClick: () => {
          this.$store.dispatch('restoreSplashImage')
        }
      });
    },
    async handleDeleteImageClick (image) {
      this.$store.commit("setModal", {
          component: TextComponent,
          mounted: true,
          header: "Confirm delete",
          props: {
              text: `Are you sure you want to delete image "${image.title}"?` },
              goodClick: async () => {
                  await this.$store.dispatch('deleteGalleryImage', image.id)
                  this.refreshGallery()
              }
      });
    },
    cancelChangeSplashHandler: function () {
      document.getElementById("splash-image-field").value = ''
      this.previewSplash = null
      this.localSplashFile = null
    },
    filterChange: function (e) {
      this.filter = e.target.value
    },
    async saveImageData (img) {
      const resp = this.$store.dispatch('handleSaveGalleryUpdate', img)
      if (resp && resp.success) {
        this.refreshGallery()
      }
    },
    splashImageUploadHandler (e) {
      if (e.target && e.target.files && e.target.files.length > 0) {
        const img = new Image()
        const imagePreview = URL.createObjectURL(e.target.files[0])
        img.onload = () => this.previewSplash = imagePreview
        img.src = imagePreview
      }
      this.localSplashFile = {
        url: e.target.value,
        files: e.target.files[0]
      }
    },
    galleryImageUploadHandler (e) {
      if (e.target && e.target.files && e.target.files.length > 0) {
        const img = new Image()
        const imagePreview = URL.createObjectURL(e.target.files[0])
        img.onload = () => this.previewNewGalleryImage = imagePreview
        img.src = imagePreview
      }
      this.addGalleryImage.image = e.target.files[0]
    },
    async submitNewGalleryImageHandler () {
      const { title } = this.addGalleryImage
      if ( title && title !== '') {
        this.uploadingImage = true
        const resp = await this.$store.dispatch('uploadGalleryImage', this.addGalleryImage)
        if (resp && resp.success) {
          this.addImageFormToggle()
          this.refreshGallery()
          this.uploadingImage = false
        }
      }
    }
  },
  computed: {
    gallery: function () {
      return this.$store.getters.gallery
    },
    categories: function () {
      return this.galleryImages.reduce((p, c) => { 
        return c.category && c.category !== '' && !p.includes(c.category)
          ? [...p, c.category] : p
      }, [])
    },
    emptySplash: function () {
      return this.$store.getters.splashLoaded && this.splashImage.includes('/null')
    },
    splashImage: function () {
      return this.$store.getters.splash
    },
    galleryLink: function () {
      const id = this.$store.getters.user && this.$store.getters.user.resourceid
      return `${api}/site/resources/gallery_images/${id || ''}`
    },
    categoryLink: function () {
      const id = this.$store.getters.user && this.$store.getters.user.resourceid
      return `${api}/site/resources/gallery_images/${id || ''}/`
    },
    featuredLink: function () {
      const id = this.$store.getters.user && this.$store.getters.user.resourceid
      return `${api}/site/resources/featured_images/${id || ''}`
    },
    displayedImages: function () {
      const dImages = this.filter && this.filter !== '' ? [...this.$store.getters.gallery.data].filter(i => {
        return this.filter === 'all' || i.category === this.filter
      }) : []
      return dImages
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/colors.scss";
.edit-website-images {
  .icon {
    width: 200px;
    &.red span {
      background-color: rgb(122, 0, 0);
    }
  }
  input[type=file] {
    background-color: $fieldBg;
    width: calc(100% - 30px);
    padding: 15px 10px;
    border-radius: 3px;
    border: 2px dotted $fieldShadow;
  }
  p {
    line-height: 1.7rem;
  }
  h4 {
    font-size: 1.3rem;
    margin-bottom: 10px;
    color: $maroon;
  }
  .current-splash-label {
    padding: 6px 10px;
    display: inline-block;
    margin-left: -2px;
    background-color:  rgb(155, 155, 155);
    color: #e9e9e9;
  }
  .splash-image {
    width: 100%;
    max-width: 900px;
  }
  .current-splash-image {
    border: 2px solid rgb(223, 223, 223);
    box-shadow: 0 0 0 2px rgb(155, 155, 155);
  }
  .filter-controls {
    background-color: gray;
    padding: 3px 10px;
    color: #fff;
    font-weight: bold;
    background-color: $maroon;
    border-radius: 5px;
    margin-bottom: 20px;
    select { 
      margin-left: 20px;
      border-radius: 4px;
      min-width: 130px;
      option {
        font-size: 1.2rem;
      }
    }
  }
  .tab-content {
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.164);
    background-color: rgb(235, 235, 235);
    width: calc(100% - 20px);
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 16px;
    display: block;
  }

  .img-upload-module {
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    margin-top: 15px;
    background-color: #fff;
    padding: 14px 10px;
    border-radius: 4px;
    button {
      padding: 10px 13px;
    }
    img { 
      width: 98%;
      margin: 10px auto;
    }
  }
  .show-in-gallery-form {
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    width: calc(100% - 30px);
    padding: 15px;
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 4px;
    input[type=text] {
      padding: 15px 10px;
    }
    img {
      box-shadow: 0 0 0 1px rgb(168, 168, 168);
      display: block;
      margin: 15px auto 15px auto;
      width: 100%;
      max-width: 500px;
      min-width: 300px;
      border: 4px solid #fff;
    }
    select {
      padding: 15px 14px;
      border-radius: 5px;
    }
    label {
      display: block;
      margin-top: 20px;
      padding-bottom: 10px;
      color: rgb(88, 88, 88);
    }
    .cat-group {
      input[type=text] {
        width: 80%;
        margin-right: 10px;
      }
    }
  }
  .card-title {
    margin: 0;
    margin-bottom: 23px;
    display: block;
    font-size: 1.1rem;
    font-weight: bold;
    color: #505050;
    border-bottom: 1px solid rgb(165, 165, 165);
    padding: 10px 0 15px 4px;
  }
}
</style>
